// extracted by mini-css-extract-plugin
export var contentBody = "_d2-9";
export var headerImage = "_d2-2";
export var imageButton = "_d2-7";
export var imageButtonIcon = "_d2-8";
export var imageHeader = "_d2-4";
export var imageHeaderText = "_d2-5";
export var imageOverlay = "_d2-3";
export var imageTitle = "_d2-6";
export var imageWrapper = "_d2-1";
export var taskList = "_d2-a";
export var widget = "_d2-0";